import { documentBundlesApi } from 'app/services/api';
import _ from 'lodash';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const DOCUMENT_BUNDLES_ACTION_TYPE = createNamedActions('documentBundles', {
  GET_DOCUMENT_BUNDLES: 'GET_DOCUMENT_BUNDLES',
  CREATE_DOCUMENT_BUNDLE: 'CREATE_DOCUMENT_BUNDLE',
  EDIT_DOCUMENT_BUNDLE: 'EDIT_DOCUMENT_BUNDLE',
  DELETE_DOCUMENT_BUNDLE: 'DELETE_DOCUMENT_BUNDLE',
  REORDER_DOCUMENT_TYPES_IN_BUNDLE: 'REORDER_DOCUMENT_TYPES_IN_BUNDLE',
});

const documentBundlesSchema = new schema.Entity(
  'data',
  {},
  {
    idAttribute: 'id',
    processStrategy: ({ id, name, companyId, isGlobal, documentBundleDocumentTypes }) => ({
      documentBundleTypeId: id,
      documentBundleTypeName: name,
      companyId,
      isGlobal,
      documentBundleDocumentTypes: _.reduce(
        documentBundleDocumentTypes,
        (acc, { bundleId, typeId, ...documentBundleType }) => ({
          ...acc,
          [typeId]: {
            ...documentBundleType,
            documentBundleTypeId: bundleId,
            documentTypeId: typeId,
          },
        }),
        {},
      ),
    }),
  },
);

export const getDocumentBundlesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentBundlesApi.getDocumentBundles(params);

  return dispatch({
    type: DOCUMENT_BUNDLES_ACTION_TYPE.GET_DOCUMENT_BUNDLES,
    payload: normalize(data, [documentBundlesSchema]).entities.data,
  });
});

export const createDocumentBundleAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentBundlesApi.createDocumentBundle(params);

  return dispatch({
    type: DOCUMENT_BUNDLES_ACTION_TYPE.CREATE_DOCUMENT_BUNDLE,
    payload: normalize(data, documentBundlesSchema).entities.data[data.id],
    data,
  });
});

export const editDocumentBundleAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentBundlesApi.editDocumentBundle(params);

  return dispatch({
    type: DOCUMENT_BUNDLES_ACTION_TYPE.EDIT_DOCUMENT_BUNDLE,
    payload: normalize(data, documentBundlesSchema).entities.data[data.id],
  });
});

export const deleteDocumentBundleAction = catchAsyncActionError(params => async dispatch => {
  await documentBundlesApi.deleteDocumentBundle(params);

  return dispatch({
    type: DOCUMENT_BUNDLES_ACTION_TYPE.DELETE_DOCUMENT_BUNDLE,
    meta: params,
  });
});

export const reorderDocumentTypesInBundleAction = params => async dispatch => {
  dispatch({
    type: DOCUMENT_BUNDLES_ACTION_TYPE.REORDER_DOCUMENT_TYPES_IN_BUNDLE,
    payload: params,
  });

  // direct api call used for immediate list update after finish drag-n-drop
  documentBundlesApi
    .reorderDocumentBundleTypes(params)
    .then(({ data }) =>
      dispatch({
        type: DOCUMENT_BUNDLES_ACTION_TYPE.EDIT_DOCUMENT_BUNDLE,
        payload: normalize(data, documentBundlesSchema).entities.data[data.id],
      }),
    )
    .catch(Error);
};

export const addDocumentTypeToBundleTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentBundlesApi.addDocumentBundleType(params);

  return dispatch({
    type: DOCUMENT_BUNDLES_ACTION_TYPE.EDIT_DOCUMENT_BUNDLE,
    payload: normalize(data, documentBundlesSchema).entities.data[data.id],
  });
});

export const editDocumentTypeInBundleTypeAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await documentBundlesApi.editDocumentBundleType(params);

    return dispatch({
      type: DOCUMENT_BUNDLES_ACTION_TYPE.EDIT_DOCUMENT_BUNDLE,
      payload: normalize(data, documentBundlesSchema).entities.data[data.id],
    });
  },
);

export const deleteDocumentTypeFromBundleTypeAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await documentBundlesApi.deleteDocumentBundleType(params);

    return dispatch({
      type: DOCUMENT_BUNDLES_ACTION_TYPE.EDIT_DOCUMENT_BUNDLE,
      payload: normalize(data, documentBundlesSchema).entities.data[data.id],
    });
  },
);
